module.exports = __webpack_public_path__ + "83ef4b857672ba79214273763260973a.pdf";